import palette, { themeColorTokens } from '../palette';

export default {
  tooltip: {
    backgroundColor: palette.common.white,
    color: themeColorTokens.tooltipText,
    elevation: 3,
    fontSize: '0.8rem',
    fontWeight: 'normal',
  },
};
